module.exports = __webpack_public_path__ + "img/goldschmiede_ladenwerkstatt.77c7823c.jpg";